class Costos {
  constructor(data) {
    this.importeTotal = data.importeTotal;
    this.detalle = data.detalle;
  }
}
export default Costos;
